export enum DataType {
    Text, List, Title, Subtitle, Caldendar
}

export type ITest = {
    name: string;
    included: boolean;
}

export type Paragraph = {
    children?: Paragraph[];
    data?: (string | JSX.Element)[];
    type: DataType;
}

export type IOfferLevel = {
    title: string;
    subtitle?: string;
    tests?: ITest[];
    text?: string[];
    code: string;
    displayOrder: number;
}

export type IWhy = {
    title: string;
    paragraph: Paragraph[];
}

export type ITile = {
    title: string;
    subtitle?: string;
    text: string[];
    buttonLabel: string;
    href: string;
}

export type IOffer = {
    id: string;
    title: string;
    subtitle?: string;
    shortTitle?: string;
    mainText: Paragraph[];
    href?: string;
    buttonLabel?: string;
    risks?: string[];
    risksDetail?: Paragraph[];
    why?: IWhy;
    docs?: string[];
    tile?: ITile;
    offerLevels?: IOfferLevel[];
    subOffers?: IOffer[];
    displayOrder: number;
}